import React, { Component } from "react";
import "./index.css";

export default class InfoSection extends Component {
  render() {
    return (
      <div id="infosection" >
        <div className="landing-header" style={{ marginTop: "10rem" }}>
          <h1>Surveillance</h1>
          <h3 style={{ color: "gray" }}>3 datasets in one</h3>
        </div>
        <div className="infographics">
          <div>
            <div className="center-child">
            <svg
              height="110"
              viewBox="0 0 150 110"
              width="150"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
            >
            <linearGradient x1="100%" y1="27.3355553%" x2="0%" y2="72.6644447%" id="linearGradient-2">
            <stop stopColor="#A445B2" offset="0%"></stop>
            <stop stopColor="#D41872" offset="51.7099809%"></stop>
            <stop stopColor="#FF0066" offset="100%"></stop>
        </linearGradient>
              <text className="svg-grad" style={{fill:'url(#linearGradient-2)'}}>
                <tspan x="0" y="108">
                  8K
                </tspan>
              </text>
            </svg>
            </div>
            <p>Environment Samples</p>
          </div>
          <div>
          <div className="center-child">
            <svg
              height="110"
              viewBox="0 0 150 110"
              width="150"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
            >
        <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="linearGradient-1">
            <stop stopColor="#00ECBC" offset="0%"></stop>
            <stop stopColor="#007ADF" offset="100%"></stop>
        </linearGradient>
              <text className="svg-grad" style={{fill:"url(#linearGradient-1)"}}>
                <tspan x="0" y="108">
                  8K
                </tspan>
              </text>
            </svg>
            </div>
            <p>Keywords Samples</p>
          </div>
          <div>
          <div className="center-child">
            <svg
              height="110"
              viewBox="0 0 150 110"
              width="150"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
            >
              <linearGradient id="a" x1="50%" x2="50%" y1="100%" y2="0%">
                <stop offset="0" stopColor="#00e3ae" />
                <stop offset="1" stopColor="#9be15d" />
              </linearGradient>
              <text className="svg-grad">
                <tspan x="0" y="108">
                  8K
                </tspan>
              </text>
            </svg>
            </div>
            <p>Emotion Samples</p>
          </div>
        </div>
      </div>
    );
  }
}
